<script>
export default {
  name: "InventoryPictures",
  props: {
    count: {
      type: Number,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    uploadedImages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {},
  methods: {
    imageFor(index) {
      return `/product_image/${this.$route.params.storeId}-${this.itemId}-${index}-250`;
    },
    imageFromFile(file) {
      var _URL = window.URL || window.webkitURL;
      const data = _URL.createObjectURL(file);
      return data;
    },
  },
};
</script>

<template>
  <v-sheet>
    <v-slide-group v-model="model">
      <v-slide-item class="mx-1">
        <label id="file-select">
          <v-card
            width="120"
            height="120"
            tile
            outlined
            style="border-color: var(--v-primary-base); cursor: pointer"
          >
            <v-container fluid style="height: 100%">
              <v-row style="height: 100%" class="align-center justify-center">
                <v-icon large color="primary">$camera</v-icon>
              </v-row>
            </v-container>
          </v-card>
          <input
            type="file"
            style="display: none"
            @change="$emit('upload', $event.target.files[0])"
          />
        </label>
      </v-slide-item>
      <v-slide-item v-for="i in count" :key="i" class="mx-1">
        <v-card flat tile class="mr-1" :height="120" :width="120">
          <v-img :src="imageFor(i - 1)" aspect-ratio="1">
            <template v-slot:placeholder>
              <v-skeleton-loader type="image" />
            </template>
          </v-img>
        </v-card>
      </v-slide-item>
      <v-slide-item
        v-for="file in uploadedImages"
        :key="file.name"
        class="mx-1"
      >
        <v-card flat tile class="mr-1" :height="120" :width="120">
          <v-img :src="imageFromFile(file)" aspect-ratio="1" contain>
            <template v-slot:placeholder>
              <v-skeleton-loader type="image" />
            </template>
          </v-img>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>
